import {TM_TRD_GROUP_SET} from "../../../function/GroupDataModel";
import { LogD } from "../../../function/LogLapper";

/**
 * ライン情報
 */
export type GraphLineData = {
  XValues: number[],
  YValues: string[],
  PLCNo: string,
  AICardNo: string,
  ChannelNo:string ,
  ItemName:string ,
  FileName: string,
  MaxValue : number,
  MinValue : number,
  YaxisOffset: number,
  XaxisStartIndex: number,
  XaxisSpanCount: number,
  SamplingCount: number,
  SamplingPeriod: number,
  Unit : string,
}

/**
 * ライン情報
 */
export type GraphLineDatas = {
  RGrahData: GraphLineData;
  SGrahData: GraphLineData;
  TGrahData: GraphLineData;
};

/**
 * CSVファイルの存在する時間リストを取得
 * @param devIndex 
 * @param targetDay 
 * @returns 
 */
export const GetTimeList = (devIndex: string, targetDay : string ,isLowPassFlg : boolean) : Promise<string[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/PhaseCurrent/GetDataTimeList";
    const param = `?devIndex=${devIndex}&isLowPassFlg=${isLowPassFlg}&targetTime=${targetDay}`;
    //console.debug(url + param);
    fetch(url + param)
    .then((res) => res.json())
      .then((result: string[]) => {
        //console.debug(['result', result]);
        if (TimeListValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const TimeListValidate = (data: string[]) => {
    LogD(`GetTimeListValidate ckeck ${data}`,true);
    if (data == undefined) return false;
      LogD("GetTimeListValidate ckeck ok",true);
    return true;
};

/**
 * CSVファイルの存在する時間リストを取得
 * 最新の時間を取得
 * @param devIndex 
 * @returns 
 */
export const GetLatesTime = (devIndex: string) : Promise<string> => {
  return new Promise((resolve, reject) => {
    const url = "api/PhaseCurrent/GetDataLatesTime";
    console.debug("1★");
    const param = `?devIndex=${devIndex}`;
    console.debug(url + param);
    fetch(url + param)
     .then((res) => res.json())
      .then((result: string) => {
        console.debug("2★");
        console.debug(result);
        if (LatesTimeValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const LatesTimeValidate = (data: string) => {
    console.debug("LatesTimeValidate ckeck");
    if (data == undefined) return false;
      LogD("LatesTimeValidate ckeck ok",true);
    return true;
};

/**
 * CSVファイルの取得
 * @param devIndex 
 * @param targetDay 
 * @param millisecond 
 * @returns 
 */
export const GetPhaseCurrentGraph = (devIndex: string, targetDay: string , millisecond : number,isLowPassFlg:boolean): Promise<GraphLineDatas> => {
  //console.debug(['GetPhaseCurrentGraph()', devIndex, targetDay]);

  return new Promise((resolve, reject) => {
    const url = "api/PhaseCurrent/GetPhaseCurrentGraph";
    const param = `?devIndex=${devIndex}&targetTime=${targetDay}&millisecond=${millisecond}&isLowPassFlg=${isLowPassFlg}`;
    fetch(url + param)
      .then((res) => res.json())
      .then((result: GraphLineDatas) => {
        //console.debug(['result', result]);
        if (PhaseCurrentGraphValidate(result)) {
          resolve(result);
        }
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const PhaseCurrentGraphValidate = (data: GraphLineDatas) => {
  if (data.RGrahData === null || data.SGrahData === null || data.TGrahData === null) {
    return false;
  }
  return true;
};
